import CartProgressIndicator from './CartProgressIndicator'

export default CartProgressIndicator
// eslint-disable-next-line import/export
export * from './CartProgressIndicator'
